import { render } from "./VentaFacturar.vue?vue&type=template&id=35f9fe27&scoped=true"
import script from "./VentaFacturar.vue?vue&type=script&lang=js"
export * from "./VentaFacturar.vue?vue&type=script&lang=js"

import "./VentaFacturar.vue?vue&type=style&index=0&id=35f9fe27&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f9fe27"]])

export default __exports__